import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from '../../api/api';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { checkExistingKey } from '../../constant/constant';

export const fetchElective = createAsyncThunk(
  'appElective/fetchElective',
  async (param, thunkApi) => {
    // console.log("fetch param",param)
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_ELECTIVE_PATH,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return { data: response.data };
    } catch (e) {}
  }
);
export const postElective = createAsyncThunk(
  'appElective/postElective',
  async (param) => {
    try {
      // console.log("start===>", { ...param, ...commonMoodlePayload })
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.POST,
        { ...param, ...commonMoodlePayload }
      );
      // console.log("response post", response);
      return response.data;
    } catch (e) {}
  }
);

export const electiveSlice = createSlice({
  name: 'electiveSlice',
  initialState: {
    loading: false,
    success: false,
    data: null,
    userSelection: false
  },
  reducers: {
    updateElectiveData: (state, action) => {
      state.data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchElective.pending, (state) => {
      state.loading = true;
      state.userSelection = false;
    });
    builder.addCase(fetchElective.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
      const isEnrolled = (action.payload.data?.childs || [])?.findIndex(
        (val) => val?.isenroled
      );

      // 1: modal has been shown
      // 0: modal has not been shown but the user has been enrolled
      // null: nothing is done
      let check = checkExistingKey(action.meta.arg.lpid);
      let storage = null;
      if ((!action.payload.data?.childs?.length || isEnrolled < 0) && !check) {
        if (check) {
          const temp = check?.storage;
          temp.splice(check?.index, 1);
          localStorage.setItem('showedEnrolled', JSON.stringify(temp));
        }
      }
      if (isEnrolled >= 0 && action.payload.data?.childs?.length) {
        const enrolledCourse = action.payload.data?.childs[isEnrolled];
        storage = check?.data?.showedEnrolled;
        if (!storage?.length) {
          storage = null;
        }
        if (!storage && typeof check?.data?.showedEnrolled !== 'string') {
          const object = {
            parentId: action.meta.arg.lpid,
            childId: enrolledCourse?.id,
            showedEnrolled: '0'
          };
          const firstTemp = JSON.parse(
            localStorage.getItem('showedEnrolled') || '[]'
          );
          const temp = Array.isArray(firstTemp)
            ? firstTemp
            : check?.storage || [];
          temp.push(object);
          localStorage.setItem('showedEnrolled', JSON.stringify(temp));
        } else if (storage === '0') {
          const temp = check?.storage || [];
          temp[check?.index].showedEnrolled = '1';
          localStorage.setItem('showedEnrolled', JSON.stringify(temp));
        }
      }
      action.payload.data?.childs?.find((child) => {
        if (child.selected) {
          state.userSelection = true;
        }
      });
    });
    builder.addCase(fetchElective.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(postElective.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postElective.fulfilled, (state, action) => {
      if (action.payload.status) {
        state.success = true;
        state.userSelection = true;
      }
      state.loading = false;
    });
    builder.addCase(postElective.rejected, (state) => {
      state.loading = false;
    });
  }
});
export const { updateElectiveData, updateUserSelection } =
  electiveSlice.actions;
export default electiveSlice.reducer;
